import { PanoramaSharp } from "@mui/icons-material";
import { apiClient } from "../api/apiclient"

export const getCourse = (token) =>
    apiClient.get("/courses", {
        headers: { Authorization: `Bearer ${token}` },
    });

export const getProgramme = (token) =>
    apiClient.get("/Programmes", {
        headers: { Authorization: `Bearer ${token}` },
    });

export const postDateConfiguration = (DateConfigurationRequest, token) =>
    apiClient.post("/date-configuration", DateConfigurationRequest, {
        headers: { Authorization: `Bearer ${token}` },
    });


export const getDateConfiguration = () =>
    apiClient.get("/public/date-configuration/all", {
        // headers: { Authorization: `Bearer ${token}` },
    });

export const editdateConfiguration = (updatedDateconfiguration, token) =>
    apiClient.put('/date-configuration', updatedDateconfiguration, {
        headers: { Authorization: `Bearer ${token}` },
    });